import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { Types, IaActions } from "../ducks/ia";
import { UserProps } from "../../interfaces/pacientes.interface";
import { sendErrorSentryOrLocalHost } from "../../utils/funcs";

export function* getIaSummary(): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	if (!user_logado || !user_logado.token) {
		yield put(IaActions.ia_summary_failure("Usuário não autenticado ou token ausente."));
		return;
	}

	async function apiCall() {
		try {
			const requestOptions = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}ia/copiloto/resumo`,
				requestOptions
			);
			const response = await res.json();

			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message: "Erro ao buscar resumo do copiloto IA - getIaSummary",
				tags: {
					endpoint: "/ia/copiloto/resumo",
					file: "src/store/sagas/ia.ts",
				},
			});
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		if (response && response.status === "success" && response.code === 0 && response.resumo) {
			yield put(IaActions.ia_summary_success(response.resumo));
		} else {
			const errMsg = response?.message || "Erro desconhecido ao carregar resumo do copiloto.";
			yield put(IaActions.ia_summary_failure(errMsg));
		}
	} catch (e: any) {
		yield put(IaActions.ia_summary_failure(e.message || "Erro na requisição."));
	}
}

export function* IaSaga(): any {
	return yield all([
		takeLatest(Types.IA_SUMMARY_REQUEST, getIaSummary),
	]);
}
